import React, { useEffect, useLayoutEffect, useRef } from "react";

// import data from "./ByPanelSliderData.json";
/* Imports */

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import * as am4maps from "@amcharts/amcharts4/maps";
// import am4geodata_continentsLow from "@amcharts/amcharts4-geodata/continentsLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const ChartSlider = (props) => {
  const {data} = props 
  const x = useRef(null);
  useLayoutEffect(() => {
    let startTime = new Date(data[0]?.date).getTime();
    let endTime = new Date(data[data.length-1]?.date).getTime();

    let productData = data.map(({ date, product }) => {
      let newProduct = product / 100000;
      return { date: date, product: newProduct };
    });

    var currentTime;

    var container = am4core.create("chartdiv-slider", am4core.Container, {
      export: {
        enabled: true,
        menu: [
          {
            class: "export-main",
            menu: [
              {
                label: "Download",
                menu: ["PNG", "JPG", "CSV"],
              },
              {
                label: "Annotate",
                action: "draw",
                menu: [
                  {
                    class: "export-drawing",
                    menu: ["PNG", "JPG"],
                  },
                ],
              },
            ],
          },
        ],
      },
      responsive: {
        enabled: true,
      },
    });
    container.width = am4core.percent(100);
    container.height = am4core.percent(80);
    container.logo.opacity = 0;
    container.logo.display = "none";
    container.logo.color = "white";
    container.logo.height = 25 ;
    container.logo.width = 5;
    container.exporting.menu = new am4core.ExportMenu();
    container.exporting.menu.align = "left";
    container.exporting.menu.verticalAlign = "bottom";
    container.exporting.menu.items = [
      {
        label: "...",
        menu: [
          {
            label: "Image",
            menu: [
              { type: "png", label: "PNG" },
              { type: "jpg", label: "JPG" },
              { type: "svg", label: "SVG" },
              { type: "pdf", label: "PDF" },
            ],
          },
          {
            label: "Data",
            menu: [
              { type: "json", label: "JSON" },
              { type: "csv", label: "CSV" },
              { type: "xlsx", label: "XLSX" },
              { type: "html", label: "HTML" },
              { type: "pdfdata", label: "PDF" },
            ],
          },
          {
            label: "Print",
            type: "print",
          },
        ],
      },
    ];
    container.exporting.filePrefix = Date();

    if (
      (window.document.documentElement.lang === "fa") &
      (window.document.documentElement.dir === "rtl")
    ) {
      container.rtl = true;
      // console.log("x is rtl")
    } else {
      container.rtl = false;
      // console.log("x is ltr")
    }

    // container.responsive.enabled = true;

    // updates all elements
    function setTime() {
      var time = new Date(
        startTime + (endTime - startTime) * slider.start
      ).getTime();
      var roundedTime = am4core.time.round(new Date(time), "minute").getTime();
      if (roundedTime !== currentTime) {
        currentTime = roundedTime;
        var count = lineSeries.dataItems.length;
        if (slider) {
          for (var i = 0; i < count; i++) {
            var dataItem = lineSeries.dataItems.getIndex(i);
            
            
            if (i < slider.start * count) {
              dataItem.show(500, 0, ["valueY"]);
            } else {
              dataItem.hide(500, 0, 0, ["valueY"]);
            }
          }
        }
      }
    }

    var chart = container.createChild(am4charts.XYChart);
    chart.padding(0, 50, 50, 50);
    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.tooltip.background.pointerLength = 4;
    dateAxis.tooltip.background.fillOpacity = 1;
    dateAxis.tooltip.background.fill = am4core.color("#666666");
    dateAxis.tooltip.background.stroke = dateAxis.tooltip.background.fill;

    chart.height = 300;
    chart.align = "bottom";

    var gradientFill = new am4core.LinearGradient();
    gradientFill.addColor(am4core.color("#ffffff"), 0, 0);
    gradientFill.addColor(am4core.color("#ffffff"), 1, 1);
    gradientFill.rotation = 90;

    chart.background.fill = gradientFill;

    

    dateAxis.renderer.inside = true;
    dateAxis.renderer.ticks.template.disabled = true;
    dateAxis.renderer.grid.template.strokeDasharray = "3,3";
    dateAxis.renderer.grid.template.strokeOpacity = 0.2;
    dateAxis.renderer.line.disabled = true;
    dateAxis.tooltip.dateFormatter.dateFormat = "YYYY-MM-dd HH:mm";
    dateAxis.renderer.inside = false;
    dateAxis.renderer.labels.template.fillOpacity = 0.4;
    dateAxis.renderer.minLabelPosition = 0.03;
    dateAxis.renderer.labels.template.fill = am4core.color("#000000");
    dateAxis.renderer.grid.template.stroke = am4core.color("#000000");

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.ticks.template.disabled = true;
    valueAxis.min = 0;
    valueAxis.max = "auto";
    valueAxis.renderer.minGridDistance = 20;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.line.disabled = true;
    valueAxis.tooltip.disabled = true;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.labels.template.fillOpacity = 0.4;
    valueAxis.renderer.labels.template.fill = am4core.color("#000000");
    valueAxis.renderer.grid.template.stroke = am4core.color("#000000");
    valueAxis.renderer.inside = true;
    valueAxis.renderer.baseGrid.strokeOpacity = 0.2;
    valueAxis.renderer.baseGrid.stroke = am4core.color("#000000");

    var lineSeries = chart.series.push(new am4charts.LineSeries());
    lineSeries.dataFields.valueY = "product";
    lineSeries.dataFields.dateX = "date";
    lineSeries.tooltipText = "{valueY.workingValue}W/h";
    lineSeries.stroke = am4core.color("orange");
    lineSeries.tooltip.background.fillOpacity = 0;
    lineSeries.tooltip.autoTextColor = false;
    lineSeries.tooltip.label.fill = am4core.color("black");
    lineSeries.tooltip.filters.clear();
    lineSeries.tooltip.pointerOrientation = "vertical";
    lineSeries.strokeWidth = 2;
    lineSeries.tensionX = 0.7;
    lineSeries.showOnInit = false;

    lineSeries.events.on("datavalidated", function () {
      lineSeries.dataItems.each(function (dataItem) {
        dataItem.hide(0, 0, 0, ["valueY"]);
      });
    });

    var negativeRange = valueAxis.createSeriesRange(lineSeries);
    negativeRange.value = 0;
    negativeRange.endValue = -100;
    negativeRange.contents.stroke = am4core.color("yellow");
    negativeRange.contents.fill = negativeRange.contents.stroke;

    chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm";

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "panY";
    chart.cursor.yAxis = dateAxis;
    chart.cursor.lineY.strokeOpacity = 1;

    chart.events.on("ready", function () {
      createSlider();
    });

    var slider;

    var playButton;

    function createSlider() {
      var sliderContainer = container.createChild(am4core.Container);

      sliderContainer.width = am4core.percent(100);
      sliderContainer.valign = "bottom";
      sliderContainer.padding(0, 50, 25, 50);
      sliderContainer.layout = "horizontal";
      sliderContainer.height = 100;

      playButton = sliderContainer.createChild(am4core.PlayButton);
      playButton.valign = "middle";
      playButton.events.on("toggled", function (event) {
        if (event.target.isActive) {
          play();
        } else {
          stop();
        }
      });

      slider = sliderContainer.createChild(am4core.Slider);
      slider.valign = "middle";
      slider.margin(0, 0, 0, 0);
      slider.background.opacity = 0.3;
      slider.opacity = 0.7;
      slider.background.fill = am4core.color("#ffffff");
      slider.marginLeft = 50;
      slider.height = 15;
      slider.events.on("rangechanged", function () {
        setTime();
        
      });

      slider.startGrip.events.on("drag", function () {
        stop();
        sliderAnimation.setProgress(slider.start);
      });

      sliderAnimation = slider
        .animate({ property: "start", to: 1 }, 50000, am4core.ease.linear)
        .pause();
      sliderAnimation.events.on("animationended", function () {
        playButton.isActive = false;
      });
    }

    var sliderAnimation;

    function play() {
      if (slider) {
        if (slider.start >= 1) {
          slider.start = 0;
          sliderAnimation.start();
        }
        sliderAnimation.resume();
        playButton.isActive = true;
      }
    }

    function stop() {
      sliderAnimation.pause();
      playButton.isActive = false;
    }

    // setTimeout(function () {
    //   play();
    // }, 1000);

    
    x.current = container;

    chart.data = productData;

    return () => {
      container.dispose();
    };
  });

  // componentWillUnmount() {
  //   if (this.chart) {
  //     this.chart.dispose();
  //   }
  // }

  return (
    <div id="chartdiv-slider" style={{ width: "100%", height: "300px" }}></div>
  );
};

export default React.memo(ChartSlider);
